export default __webpack_public_path__ + "static/media/curriculum-pa-preview.596c1d10.png";